import { useComputed } from "@homebound/beam";
import { ListFieldState, ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./aiFieldProposalForm";
import { findAiFieldProposal } from "./bindAiProposal";

/**
 * The entity's DELETE proposal, or the proposal for `fieldName` if the agent proposed one.
 */
export function useAiFieldProposal(
  fieldProposals: ListFieldState<AiFieldProposalFormValue> | undefined,
  fieldName: string,
): ObjectState<AiFieldProposalFormValue> | undefined {
  return useComputed(() => findAiFieldProposal(fieldProposals?.rows ?? [], fieldName), [fieldProposals, fieldName]);
}
